export const inputCls =
  "mt-2 w-full rounded-none border-0 border-b border-white/25 bg-transparent px-0 py-3 text-base text-[var(--bone)] placeholder:text-[#8f8a7e] focus:border-[var(--signal)] focus:outline-none focus:ring-0 transition-colors md:text-lg";

export const Field = ({ label, id, required, className = "", children }) => (
  <label htmlFor={id} className={`block ${className}`}>
    <span className="overline text-[var(--bone-2)]">
      {label}
      {required && <span className="text-[var(--signal)]"> *</span>}
    </span>
    {children}
  </label>
);

export const TextInput = ({ id, label, required, className, ...rest }) => (
  <Field id={id} label={label} required={required} className={className}>
    <input id={id} required={required} className={inputCls} data-testid={`${id}-input`} {...rest} />
  </Field>
);
